export const SET_DATA = 'SET_DATA'
export const SET_UPLOAD_DATA = 'SET_UPLOAD_DATA'
export const SET_MENU_DATA = 'SET_MENU_DATA'
export const SET_ACTIVE = 'SET_ACTIVE'
